import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\CopyMaterialResourceFromEventController::__invoke
* @see app/Http/Controllers/Planning/CopyMaterialResourceFromEventController.php
* @route '/api/planning/{event}/copy-material-resource'
*/
const CopyMaterialResourceFromEventController = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CopyMaterialResourceFromEventController.url(args, options),
    method: 'post',
})

CopyMaterialResourceFromEventController.definition = {
    methods: ["post"],
    url: '/api/planning/{event}/copy-material-resource',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Planning\CopyMaterialResourceFromEventController::__invoke
* @see app/Http/Controllers/Planning/CopyMaterialResourceFromEventController.php
* @route '/api/planning/{event}/copy-material-resource'
*/
CopyMaterialResourceFromEventController.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return CopyMaterialResourceFromEventController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\CopyMaterialResourceFromEventController::__invoke
* @see app/Http/Controllers/Planning/CopyMaterialResourceFromEventController.php
* @route '/api/planning/{event}/copy-material-resource'
*/
CopyMaterialResourceFromEventController.post = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CopyMaterialResourceFromEventController.url(args, options),
    method: 'post',
})

export default CopyMaterialResourceFromEventController